module.exports = __webpack_public_path__ + "static/media/home-jobseeker.fb68e878.jpeg";